import React from 'react';
import { Box, Typography, Grid, Link } from '@mui/material';
import './Pages.css';

function Footer() {
  return (
    <Box className="footer">
      <Grid container spacing={3}>
        <Grid item xs={4} className="footer-grid-item">
          <Typography variant="h6" gutterBottom>Help</Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">Product documentation</Link>
          </Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">Product wiki</Link>
          </Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">Media gallery</Link>
          </Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">WebSphere Portal Zone</Link>
          </Typography>
        </Grid>
        <Grid item xs={4} className="footer-grid-item">
          <Typography variant="h6" gutterBottom>Support</Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">Support page</Link>
          </Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">Supported hardware and software</Link>
          </Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">IBM Software Support Guide</Link>
          </Typography>
        </Grid>
        <Grid item xs={4} className="footer-grid-item">
          <Typography variant="h6" gutterBottom>Search & Explore</Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">Search Center</Link>
          </Typography>
          <Typography variant="body2">
            <Link href="#" color="inherit" underline="hover">Tagging & Rating</Link>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Footer;
